<template>
    <div class="rfq" >
<!--        <el-card >-->
<!--            <el-breadcrumb separator="/">-->
<!--                &lt;!&ndash; <el-breadcrumb-item :to="{ name: 'workspace' }">首页</el-breadcrumb-item> &ndash;&gt;-->
<!--                <el-breadcrumb-item>设置</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>客户端发票抬头</el-breadcrumb-item>-->
<!--            </el-breadcrumb>-->
<!--        </el-card>-->
        <main class="content">
            <el-card>
                <el-form :inline="true" :model="searchForm">
                    <el-form-item label="公司名称">
                        <el-input v-model="searchForm.companyName" placeholder="公司名称" size="mini" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="() => {this.currentPage=1;onSearch();}" size="mini">查询</el-button>
                    </el-form-item>
                </el-form>
                <el-table
                    :data="tableData"
                    v-loading="loading"
                    style="width: 100%">
                    <el-table-column prop="name" label="归属公司" width="200" fixed></el-table-column>
                    <el-table-column prop="companyName" label="公司名称" width="200"></el-table-column>
                    <el-table-column
                        prop="bankName"
                        label="开户行" width="120">
                    </el-table-column>
                    <el-table-column
                        prop="bankAccount"
                        label="开户行账号" width="150">
                    </el-table-column>
                    <el-table-column
                        prop="companyTaxNo"
                        label="税号" width="170">
                    </el-table-column>
                    <el-table-column
                        prop="registeredTel"
                        label="注册电话" width="120">
                    </el-table-column>
                    <el-table-column
                        prop="registeredAddress"
                        label="注册地址"
                        width="200">
                    </el-table-column>
                    <el-table-column
                        prop="recipient"
                        label="收件人"
                        width="100">
                    </el-table-column>
                    <el-table-column
                        prop="recipientTel"
                        label="联系电话"
                        width="100">
                    </el-table-column>
                    <el-table-column
                        prop="recipientAddress"
                        label="收件地址"
                        width="200">
                    </el-table-column>

                    <el-table-column label="操作" width="160" align="right" fixed="right">
                        <template slot="header">
                            <el-button type="primary" size="mini" @click="handleCreate()">添加发票抬头</el-button>
                        </template>
                        <template slot-scope="scope">
                            <!-- <el-button size="mini" @click="edit(scope.row)">修改</el-button> -->
                            <el-button type="text" size="mini" @click="handleDelete(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="text-align: center;padding-top: 20px">
                    <el-pagination
                        stripe
                        background
                        layout="sizes,prev, pager, next"
                        :total="total"
                        :page-sizes="[10, 20, 50, 100]"
                        v-if="total>0"
                        :page-size="pageSize"
                        @size-change="handleSizeChange"
                        @current-change="onPageChange"
                        :current-page="currentPage"
                        @prev-click="onPageChange"
                        @next-click="onPageChange">
                    </el-pagination>
                </div>
            </el-card>
        </main>
        <el-dialog title="发票信息" :visible.sync="editInvoiceDialogVisible" width="800px" :close-on-click-modal="false">
            <el-form ref="editInvoiceForm" :model="editInvoiceForm" :rules="rules" label-width="90px">
                <el-form-item label="归属公司" prop="companyId" size="mini">
                    <el-select v-model="editInvoiceForm.companyId"  placeholder="归属公司"
                        :disabled="editInvoiceForm.id != '' || editCompanyId"
                        style="width: 100%" clearable>
                        <el-option
                            v-for="item in companys"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-divider>发票信息</el-divider>
                <el-row :gutter="10">
                    <el-col :span="12">
                        <el-form-item label="公司名称" prop="companyName" size="mini">
                            <el-input v-model="editInvoiceForm.companyName" placeholder="请输入公司名称" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="公司税号" prop="companyTaxNo" size="mini">
                            <el-input v-model="editInvoiceForm.companyTaxNo" placeholder="请输入税号" clearable></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :span="12">
                        <el-form-item label="开户银行" prop="bankName" size="mini">
                            <el-input v-model="editInvoiceForm.bankName" placeholder="请输入开户银行" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="银行账号" prop="bankAccount" size="mini">
                            <el-input v-model="editInvoiceForm.bankAccount" placeholder="请输入银行账号" clearable></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :span="12">
                        <el-form-item label="注册电话" prop="registeredTel" size="mini">
                            <el-input v-model="editInvoiceForm.registeredTel" placeholder="请输入注册电话" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="注册地址" prop="registeredAddress" size="mini">
                            <el-input v-model="editInvoiceForm.registeredAddress" placeholder="请输入注册地址" clearable></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-divider>收件信息</el-divider>
                <el-row :gutter="10">
                    <el-col :span="12">
                        <el-form-item label="收件人" prop="recipient" size="mini">
                            <el-input v-model="editInvoiceForm.recipient" placeholder="请输入收件人" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="联系电话" prop="recipientTel" size="mini">
                            <el-input v-model="editInvoiceForm.recipientTel" placeholder="请输入联系电话" clearable></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item label="收件地址" prop="recipientAddress" size="mini">
                    <el-input v-model="editInvoiceForm.recipientAddress" placeholder="请输入收件地址" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editInvoiceDialogVisible = false" size="small">取 消</el-button>
                <el-button type="primary" @click="handleEditInvoice" size="small">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>

export default {

    data() {
        return {
            editInvoiceDialogVisible:false,
            editCompanyId:false,
            companys:[],
            searchForm: {
                companyName: ""
            },
            loading: false,
            total: 0,
            pageSize: 10,
            currentPage: 1,
            tableData: [],

            addOrderForm: {
                id: "",
                orderBatch: "",
            },
            exportOrderVisible: false,
            exportOrderForm: {
                orderBatch: "",
            },

            orderForm: {
                orderBatch: "",
            },
            editInvoiceForm: {
                id: "",
                companyId: "",
                companyTaxNo: "",
                bankName: "",
                bankAccount: "",
                registeredTel: "",
                registeredAddress: "",
            },
            selectData:[],//选中的数据
            rules: {
                companyId: [
                    { required: true, message: '请选择开发票公司', trigger: 'blur' }
                ],
                companyTaxNo: [
                    { required: true, message: '请输入公司税号', trigger: 'blur' }
                ],
                companyName: [
                    { required: true, message: '请输入公司名称', trigger: 'blur' }
                ],
                bankName: [
                    { required: true, message: '请输入开户银行', trigger: 'blur' }
                ],
                bankAccount: [
                    { required: true, message: '请输入银行账号', trigger: 'blur' }
                ],
                registeredTel: [
                    { required: true, message: '请输入注册电话', trigger: 'blur' }
                ],
                registeredAddress: [
                    { required: true, message: '请输入注册地址', trigger: 'blur' }
                ],
                recipient: [
                    { required: true, message: '请输入收件人', trigger: 'blur' }
                ],
                recipientTel: [
                    { required: true, message: '请输入联系方式', trigger: 'blur' }
                ],
                recipientAddress: [
                    { required: true, message: '请输入收件地址', trigger: 'blur' }
                ],
            },
        }
    },
    methods: {
        onSearch() {
            this.loading = true;
            this.selectData = [];
            let _this = this
            let cond = {...this.searchForm};

            this.$axios.post("/admin/invoice/search",{
                cond,
                page: this.currentPage - 1,size:this.pageSize
            }).then(function(response) {
                let resp = response.data;
                if( resp.header.status == 0) {
                    _this.loading = false;
                    _this.tableData = resp.data.content;
                    _this.total = resp.data.totalElements;
                }
            }).catch(function() {
            });
        },

        handleCreate(companyId) {
            this.editCompanyId = false;
            this.editInvoiceForm =  {
                id: '',
                companyId: companyId,
                companyName: '',
                companyTaxNo: '',
                bankName: '',
                bankAccount: '',
                registeredTel: '',
                registeredAddress: '',
                recipient: '',
                recipientTel: '',
                recipientAddress: '',
                valid: true,
            }
            this.editInvoiceDialogVisible = true;
            this.$refs.editInvoiceForm.clearValidate();
        },
        edit(row) {
            this.editCompanyId = true;
            this.editInvoiceForm =  {
                id: row.id,
                companyId: row.companyId,
                companyName: row.companyName,
                companyTaxNo:row.companyTaxNo,
                bankName: row.bankName,
                bankAccount: row.bankAccount,
                registeredTel: row.registeredTel,
                registeredAddress: row.registeredAddress,
                recipient: row.recipient,
                recipientTel: row.recipientTel,
                recipientAddress: row.recipientAddress,
                valid: row.valid,
            }
            this.editInvoiceDialogVisible = true;
            this.$refs.editInvoiceForm.clearValidate();
        },
        handleEditInvoice() {
            const that = this;
            this.$refs.editInvoiceForm.validate(valid => {
                if(valid) {
                    this.$axios
                    .post("/admin/invoice/save", that.editInvoiceForm)
                    .then(function (response) {
                        let resp = response.data;
                        if (resp.header.status === 0) {
                            that.$notify({
                                title: '成功',
                                message: '数据保存成功',
                                type: 'success'
                            });
                            that.editInvoiceDialogVisible = false;
                            that.onSearch();
                        } else {
                            that.$notify.error({
                                title: '错误',
                                message: resp.header.msg
                            });
                        }
                    });
                }
            });
        },
        handleDelete(row) {
            let _this = this;
            this.$confirm('是否删除【' + row.companyName + '】发票信息？', '确认信息', {
                distinguishCancelAndClose: true,
                confirmButtonText: '删除',
                cancelButtonText: '取消'
            }).then(() => {
                _this.$axios.get("/admin/invoice/delete/" + row.id)
                    .then(function (response) {
                        let resp = response.data;
                        if (resp.header.status === 0) {
                            _this.$notify({
                                title: '成功',
                                message: '数据删除成功',
                                type: 'success'
                            });
                            _this.onSearch();
                        } else {
                            _this.$notify.error({
                                title: '错误',
                                message: resp.header.msg
                            });
                        }
                    });
            })
        },
        loadCompanys(){
            let _this = this
            this.$axios.post("/admin/company/companys"
            ).then(function (response) {
                let resp = response.data;
                if (resp.header.status == 0) {
                    _this.companys = resp.data;
                }

            });

        },
        // 合并行
        objectSpanMethod({rowIndex, columnIndex }) {
            let spanOneArr = [],concatOne = 0;
            this.tableData.map((item,index)=>{
                if(index === 0){
                    spanOneArr.push(1);
                }else{
                    //第一列需合并相同内容的判断条件
                    if(item.name === this.tableData[index-1].name){
                        spanOneArr[concatOne] += 1;
                        spanOneArr.push(0);
                    }else{
                        spanOneArr.push(1);
                        concatOne = index;
                    }
                }
            });

            if(columnIndex === 0){
                const _row = spanOneArr[rowIndex];

                const _col = _row > 0 ? 1 : 0;

                return{
                    rowspan:_row,
                    colspan:_col
                }
            }

        },

        order() {
            const that = this;
            this.$refs.orderForm.validate(valid => {
                if(valid) {
                    this.$axios.post("/admin/order/customerOrder", this.orderForm)
                    .then(function (response) {
                        let resp = response.data;
                        if (resp.header.status == 0) {
                            that.$notify({
                                title: '成功',
                                message: '数据保存成功',
                                type: 'success'
                            });
                            that.orderVisible = false;
                            that.onSearch();
                        } else {
                            that.$notify.error({
                                title: '错误',
                                message: resp.header.msg
                            });
                        }
                    });
                }
            });
        },
        passIt(orderId,step,workflowId,name,totalPrice){
            this.reviewForm.pass = 'true';
            this.reviewForm.reason = '';
            this.reviewForm.orderId = orderId;
            this.reviewForm.step = step;
            this.reviewForm.workflowId = workflowId;
            this.reviewForm.name = name;
            this.reviewForm.totalPrice = totalPrice;
            this.addProcess();
        },
        showReviewDialog(orderId,step,workflowId,name,totalPrice) {//打开审核对话框
            this.reviewForm.pass = 'false';
            this.reviewForm.reason = '';
            this.reviewForm.orderId = orderId;
            this.reviewForm.step = step;
            this.reviewForm.workflowId = workflowId;
            this.reviewForm.name = name;
            this.reviewForm.totalPrice = totalPrice;
            this.reviewVisible = true;

        },
        addProcess() {//添加审核过程
            // step,pass,orderId,WorkflowId,reason


               //确定通过abc提交的总价￥123,456,78的订单吗?

            const that = this;
            let cond = {...this.reviewForm};
            let optate = "通过";
            optate = cond.pass == 'false' ? "驳回" : "通过";
            this.$confirm('确定' + optate +'【' +cond.name+'】提交的总价【￥'+cond.totalPrice+'】的订单吗？', '提示', {
                distinguishCancelAndClose: true,
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            }).then(() => {

                cond.pass = cond.pass == 'true' ? true : false;
                if (cond.pass) {
                    cond.reason = '';
                }
                cond={pass:cond.pass,reason:cond.reason,orderId:cond.orderId,step:cond.step
                    ,workflowId:cond.workflowId};
                this.$axios.post("/admin/rfq/review", cond)
                    .then(function (response) {
                        let resp = response.data;
                        if (resp.header.status == 0) {

                            that.reviewVisible = false;
                            if (resp.data == true) {//审核完毕
                                that.changeOrder(that.reviewForm.orderId);
                                that.onSearch();
                            } else {
                                that.$notify({
                                    title: '成功',
                                    message: '数据保存成功',
                                    type: 'success'
                                });
                                that.onSearch();
                            }

                        } else {
                            that.$notify.error({
                                title: '错误',
                                message: resp.header.msg
                            });
                        }
                    });
            });
        },
        changeOrder(orderId) {//修改状态为下单
            const that = this;
            this.$axios.post("/admin/rfq/reviewOver", {orderId:orderId})
                .then(function (response) {
                    let resp = response.data;
                    if (resp.header.status == 0) {


                        if(resp.data == true){//审核完毕
                            that.$notify({
                                title: '成功',
                                message: '已下单',
                                type: 'success'
                            });


                        }

                    } else {
                        that.$notify.error({
                            title: '错误',
                            message: resp.header.msg
                        });
                    }
                });
        },
        handleSizeChange(pageSize){
            this.pageSize = pageSize;
            this.onSearch();
        },
        onPageChange(currentPage) {
            this.currentPage = currentPage;
            this.onSearch();
        },
        handleToReviewDetail(row) {
            let showBtn = (row.status == 0&&row.review);

            this.$router.push({name: "customerReviewDetail", params: {from: "rfq", orderId: row.id,
                    step:row.reviewStep, workflowId:row.workflowId, name:row.consignee,totalPrice:row.totalPrice,showBtn:showBtn}})



        },
        handleToDeliver(row) {

            this.$router.push({name: "deliver", params: {from: "order", orderId: row.id
                   }});
        },
        handleSelectionChange(val) {
            this.selectData = val;
        },


    },
    created() {
        this.onSearch();
        this.loadCompanys();
    },
}
</script>
